import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/**
 * 목록을 못 불러왔을 때 빈 목록 문구 자리에 둔다(점검 N-S43).
 *
 * 실패를 「없습니다」로 그리면 학생은 할 일이 없다고, 담당자는 서식을 새로 개시하라고 읽었다. 동의 새 판을
 * 발행한 뒤 5분(토큰의 동의 캐시) 동안 모든 보호 API 가 403 이고, 백엔드가 재기동하는 동안도 그렇다.
 * 빈 목록 칸과 같은 틀(`panel`)이나 한 줄(`line`)로 두어 자리가 움직이지 않는다.
 */
export function LoadError({
  message,
  onRetry,
  size = 'panel',
  className,
}: {
  message: string;
  onRetry: () => void;
  size?: 'panel' | 'line';
  className?: string;
}) {
  const line = size === 'line';
  return (
    <div
      role="alert"
      className={cn(
        'rounded-lg border border-destructive-subtle-border bg-destructive-subtle text-center text-destructive-subtle-foreground',
        line ? 'flex flex-wrap items-center justify-center gap-2 p-3 text-sm' : 'px-4 py-10',
        className,
      )}
    >
      <AlertCircle className={line ? 'h-4 w-4 shrink-0' : 'mx-auto mb-3 h-10 w-10'} aria-hidden />
      <p className={line ? '' : 'text-sm font-semibold'}>{message}</p>
      <Button type="button" variant="outline" size="sm" className={line ? '' : 'mt-3'} onClick={onRetry}>
        다시 불러오기
      </Button>
    </div>
  );
}
